module.exports = __webpack_public_path__ + "assets/img/hill-3.dcacd478.png";